<template>
  <div class="profile-container">
    <div class="avatar-profile-card" @click="onClickCard">
      <div class="base-info">
        <UserAvatar :userInfo="userInfo" size="50"></UserAvatar>
        <div class="user-base-info">
          <div class="account-tp">
            <div class="nickname">
              {{nickname}}
            </div>
            <div class="actions-btn" @click="onShowActions" v-if="userInfo && userInfo.id">
              <Icon name="setting-o"/>
            </div>
          </div>
          <div class="account-btm">
            <div class="account-name" v-if="accountName">
              ID: {{accountName}}
            </div>
            <div class="edit-profile" @click="onEditProfile" v-if="userInfo && userInfo.id">
              编辑资料
              <icon-svg icon-class="edit"></icon-svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-box-member" v-if="isMemNovel">
      <MemberCard :member="userInfo.member_novel"></MemberCard>
    </div>

    <div class="cell-container" @click="onRecharge">
      <div class="cell-box">
        <div class="left-info">
          <icon-svg icon-class="coin"></icon-svg>
          <div class="desc">币余额</div>
          <div class="count">{{creditCount}}</div>
        </div>
        <div class="right-info">
          <div class="desc">去充值</div>
          <Icon name="arrow"></Icon>
        </div>
      </div>
    </div>

    <div class="cell-container" @click="onBookShelf">
      <div class="cell-box">
        <div class="left-info">
          <icon-svg icon-class="history"></icon-svg>
          <div class="desc">阅读历史</div>
        </div>
        <div class="right-info">
          <div class="desc"></div>
          <Icon name="arrow"></Icon>
        </div>
      </div>
    </div>

    <div class="cell-container" @click="onOrderList">
      <div class="cell-box">
        <div class="left-info">
          <icon-svg icon-class="shop-cart-line"></icon-svg>
          <div class="desc">订单列表</div>
        </div>
        <div class="right-info">
          <div class="desc"></div>
          <Icon name="arrow"></Icon>
        </div>
      </div>
    </div>

    <div class="cell-container" @click="onMomentMine">
      <div class="cell-box">
        <div class="left-info">
          <icon-svg icon-class="dongtai"></icon-svg>
          <div class="desc">我的动态</div>
        </div>
        <div class="right-info">
          <div class="desc"></div>
          <Icon name="arrow"></Icon>
        </div>
      </div>
    </div>

    <div class="cell-container" @click="onFavoriteMine">
      <div class="cell-box">
        <div class="left-info">
          <icon-svg icon-class="shoucang1"></icon-svg>
          <div class="desc">我的收藏</div>
        </div>
        <div class="right-info">
          <div class="desc"></div>
          <Icon name="arrow"></Icon>
        </div>
      </div>
    </div>

    <div class="cell-container" v-if="appSettings && appSettings.share_copy_text">
      <div class="cell-box" v-clipboard:copy="copyData" v-clipboard:success="onCopySuccess">
        <div class="left-info">
          <icon-svg icon-class="fenxiang"></icon-svg>
          <div class="desc">分享APP</div>
        </div>
        <div class="right-info">
          <div class="desc"></div>
          <Icon name="arrow"></Icon>
        </div>
      </div>
    </div>

    <div class="cell-container" @click="onFeedback">
      <div class="cell-box">
        <div class="left-info">
          <icon-svg icon-class="feedback"></icon-svg>
          <div class="desc">我要反馈</div>
        </div>
        <div class="right-info">
          <div class="desc"></div>
          <Icon name="arrow"></Icon>
        </div>
      </div>
    </div>

    <ActionSheet v-model="showActions" :actions="actions" :round="false" cancel-text="取消" close-on-click-action
                 @select="onSelect" style="z-index:10000"></ActionSheet>

    <TabbarComponent></TabbarComponent>
  </div>

</template>

<script>
  import {Button, Tabs, Tab, Icon, Toast, CellGroup, Cell, ActionSheet} from "vant"
  import TabbarComponent from "../common/TabbarComponent";
  import MemberCard from "../common/MemberCard"
  import UserAvatar from "../common/UserAvatar";

  export default {
    name: "Mine",
    components: {UserAvatar, TabbarComponent, Button, Icon, Cell, CellGroup, ActionSheet, Tabs, Tab, MemberCard},
    data() {
      return {
        userInfo: {},
        showActions: false,
        actions: [{name: "刷新"}, {name: '退出登录'}],
        appSettings: {},
      }
    },
    mounted() {
      this.initUserInfo()
      this.initSettings()
    },
    methods: {
      initSettings() {
        this.$store.dispatch("PageSettings").then((data) => {
          if (data.code === 0) {
            this.appSettings = data.data
          } else {
          }
        }, () => {
        })
      },

      onCopySuccess() {
        Toast({
          "message": '已复制下载链接 \n打开微信分享吧！',
          "duration": 5000,
        })
      },

      initUserInfo() {
        this.$store.dispatch("AccountInfoMine").then((data) => {
          if (data.code === 0) {
            this.userInfo = data.data
          } else {
            this.userInfo = {}
          }
        }, () => {
        })
      },

      onEditProfile() {
        this.$router.push("/edit_profile")
      },

      onShowActions() {
        this.showActions = true
      },

      onSelect(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.showActions = false;
        if (item.name === "退出登录") {
          this.onLogout()
        }

        if (item.name === "刷新") {
          let randId = new Date().getTime()
          let url = `${window.location.protocol}//${window.location.hostname}:${window.location.port}?randid=${randId}`
          window.location.replace(url)
        }
      },

      onRecharge() {
        this.$router.push("/cashier")
      },
      onBookShelf() {
        this.$router.push("/bookshelf")
      },
      onMomentMine() {
        this.$router.push("/moment_mine")
      },
      onFavoriteMine() {
        this.$router.push("/favorite")
      },
      onFeedback() {
        this.$router.push("/message")
      },
      onOrderList() {
        this.$router.push("/order_list")
      },
      onLogout() {
        this.$createDialog({
          type: 'confirm',
          content: `确认退出登录`,
          confirmBtn: {
            text: '确定',
            active: true,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '取消',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
          onConfirm: () => {
            this.$store.dispatch("LogoutAccount").then(
                (data) => {
                  if (data.code === 0) {
                    Toast("已退出")
                    this.initUserInfo()
                  }
                }
            )
          },
          onCancel: () => {
          }
        }).show()
      },
      onClickCard() {
        if (!this.userInfo || !this.userInfo.id) {
          this.$router.push("/login")
        }
      }
    },
    computed: {
      isMemNovel() {
        if (this.userInfo && this.userInfo.member_novel) {
          return true
        } else {
          return false
        }
      },
      creditCount() {
        if (this.userInfo && this.userInfo.credit) {
          return this.userInfo.credit
        } else {
          return 0
        }
      },
      nickname() {
        if (!this.userInfo || !this.userInfo.id) {
          return "登录/注册"
        }
        if (this.userInfo && this.userInfo.nickname) {
          return this.userInfo.nickname
        } else {
          return "[未设置]"
        }
      },
      accountName() {
        if (this.userInfo && this.userInfo.account_name) {
          return this.userInfo.account_name
        } else {
          return ""
        }
      },
      avatarUrl() {
        if (this.userInfo && this.userInfo.avatar_url) {
          return this.userInfo.avatar_url
        } else {
          return this.avatarUrlDefault
        }
      },
      copyData() {
        return this.appSettings.share_copy_text || ""
      }
    }
  }

</script>

<style lang="scss" scoped>
  .profile-container {
    min-height: 100vh;
    background: #fafafa;
    padding-bottom: 55px;
  }

  .card-box-member {
    background: white;
    padding: 0 8px 8px;
  }

  .avatar-profile-card {
    background: white;
    padding: 54px 0;

    .base-info {
      display: flex;
      margin-left: 24px;

      .user-base-info {
        margin-left: 12px;
        flex: 1 1 auto;

        .account-tp {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .nickname {
            font-size: 20px;
            line-height: 1.6;
            font-weight: bold;
            color: #333333;
          }

          .actions-btn {
            padding: 0 16px;
            color: rgba(150, 150, 150, 0.77);
          }
        }

        .account-btm {
          display: flex;
          align-items: center;
          margin-top: 12px;
          justify-content: space-between;

          .account-name {
            font-size: 12px;
            color: #a9a9a9;
          }

          .edit-profile {
            padding: 0 16px;
            color: rgba(150, 150, 150, 0.77);
          }
        }
      }


    }

    .avatar {
      img {
        width: 45px;
        height: 45px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
      }
    }
  }

  .moment-list-mine {
    margin-top: 6px;
  }

  .cell-container {

    .cell-box {
      display: flex;
      padding: 0 16px;
      min-height: 52px;
      align-items: center;
      background: white;
      justify-content: space-between;
      border-top: 1px solid #fafafa;
      border-bottom: 1px solid #fafafa;

      .left-info {
        color: #333333;
        display: flex;
        align-items: center;
        font-size: 16px;

        .desc {
          margin-left: 3px;
        }

        .count {
          margin-left: 14px;
          font-size: 22px;
          font-weight: bold;
          color: #fc9153;
        }
      }

      .right-info {
        display: flex;
        align-items: center;
        font-size: 16px;

        .desc {
          padding: 0 12px;
          color: #6b6b6b;
        }
      }
    }
  }

  .logout-cell {
    margin-top: 44px;
    padding-bottom: 12px;
  }

</style>
